import { render, staticRenderFns } from "./orderInformation.vue?vue&type=template&id=70790068&scoped=true"
import script from "./orderInformation.vue?vue&type=script&lang=js"
export * from "./orderInformation.vue?vue&type=script&lang=js"
import style0 from "./orderInformation.vue?vue&type=style&index=0&id=70790068&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70790068",
  null
  
)

export default component.exports